import React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react-lite';

import { Button, LoadingSpinner } from 'spindl-shared-components';
import TableColumnTitle from '../../molecules/TableColumnTitle';
import TableRowList from '../../molecules/TableRowList';

import styles from './Table.module.scss';
import usePresenter from './Table.presenter';
import getProps from './Table.props';
import { TableCombinedProps } from './types';

// MANUAL OVERRIDE - converted to observer Component
const Table: React.FC<TableCombinedProps> = observer((props) => {
  const {
    className,
    classes,
    tableColumnTitle,
    tableRowList,
    button,
    tableRef, // MANUAL OVERRIDE
    noRecordsFound, // MANUAL OVERRIDE
    areEntriesLoading, // MANUAL OVERRIDE
  } = usePresenter(props);

  const internalProps = getProps('');
  const currentStyle = styles.table;

  return (
    <div
      className={cx(currentStyle, className)}
      ref={tableRef} // MANUAL OVERRIDE
    >
      <div className={styles.stickyHeader}>
        <TableColumnTitle
          className={cx(styles.tableColumnTitle, classes?.tableColumnTitle)}
          {...internalProps.tableColumnTitle}
          {...tableColumnTitle}
        />
      </div>

      {areEntriesLoading ? (
        <LoadingSpinner
          className={cx(styles.loadingSpinner)}
          {...internalProps.loadingSpinner}
          isActive={true}
        />
      ) : (
        <TableRowList
        className={cx(styles.tableRowList, classes?.tableRowList)}
        {...internalProps.tableRowList}
        {...tableRowList}
      />
      )}

      {noRecordsFound && !areEntriesLoading && (
        // MANUAL OVERRIDE
        <Button
          className={cx(styles.button, classes?.button)}
          {...internalProps.button}
          {...button}
        />
      )}
    </div>
  );
}); // MANUAL OVERRIDE

export default Table;
